import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/date-icon.svg'
import _imports_1 from '@/assets/images/copy-icon.svg'
import _imports_2 from '@/assets/images/rv/arrow-blue.png'


const _withScopeId = n => (_pushScopeId("data-v-675e47c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchCon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Retail Date", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Checking Status", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Brand", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "VIN", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Special Usage", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Retail Type", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Restricted City", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Registration", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Submission", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Is Sampled", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Submit Mode", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Checking Result", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dealer Name", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dealer Code", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "SWT Code", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Is Appeal", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Y")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("N")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, " ", -1))
const _hoisted_24 = { style: {"width":"250px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Expand ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "expandIcon"
}, null, -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Collapse ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "expandIcon collapseIcon"
}, null, -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "batch-query-title" }
const _hoisted_34 = { style: {"padding":"0 8px"} }
const _hoisted_35 = { class: "list-title" }
const _hoisted_36 = { class: "list-content" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("清除")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_brand_selector = _resolveComponent("brand-selector")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_space, {
        direction: "vertical",
        class: "spaceMargin period"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_a_range_picker, {
            style: {"width":"250px"},
            placeholder: ['开始时间', '结束时间'],
            valueFormat: "YYYY/MM/DD",
            format: "YYYY/MM/DD",
            value: _ctx.period,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.period) = $event))
          }, {
            suffixIcon: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_space, {
        direction: "vertical",
        class: "spaceMargin"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createVNode(_component_a_select, {
            value: _ctx.searchParam.checkingStatus,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParam.checkingStatus) = $event)),
            style: {"width":"250px"},
            allowClear: "",
            mode: "multiple",
            maxTagCount: 1,
            placeholder: "Please select"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkingStatusList, (item) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: item.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_space, {
        direction: "vertical",
        class: "spaceMargin"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createVNode(_component_brand_selector, {
            value: _ctx.searchParam.brand,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParam.brand) = $event)),
            style: {"width":"250px"},
            ref: "select",
            allowClear: "",
            onDataLoaded: _ctx.handleBrandLoaded
          }, null, 8, ["value", "onDataLoaded"])
        ]),
        _: 1
      }),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 0,
            direction: "vertical",
            class: "spaceMargin noMarginRight"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.searchParam.vinNo,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParam.vinNo) = $event)),
                    placeholder: "请输入",
                    maxlength: 17,
                    style: {"width":"228px"}
                  }, null, 8, ["value"]),
                  _createElementVNode("img", {
                    src: _imports_1,
                    style: {"margin":"0 8px 0 -4px","cursor":"pointer"},
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.batchQueryEvent && _ctx.batchQueryEvent(...args)))
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 1,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createVNode(_component_a_select, {
                value: _ctx.searchParam.specialUsage,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchParam.specialUsage) = $event)),
                style: {"width":"250px"},
                ref: "select",
                Clear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialUsageArray, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 2,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createVNode(_component_a_select, {
                value: _ctx.searchParam.retailType,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchParam.retailType) = $event)),
                style: {"width":"250px"},
                ref: "select",
                Clear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retailTypeArray, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 3,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createVNode(_component_a_select, {
                value: _ctx.searchParam.restrictedCity,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchParam.restrictedCity) = $event)),
                style: {"width":"250px"},
                ref: "select",
                Clear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restrictedCityArray, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 4,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createVNode(_component_a_range_picker, {
                value: _ctx.registration,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registration) = $event)),
                valueFormat: "YYYY/MM/DD",
                format: "YYYY/MM/DD",
                placeholder: ['开始时间', '结束时间'],
                style: {"width":"250px"}
              }, {
                suffixIcon: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 5,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _createVNode(_component_a_range_picker, {
                value: _ctx.submission,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.submission) = $event)),
                valueFormat: "YYYY/MM/DD",
                format: "YYYY/MM/DD",
                placeholder: ['开始时间', '结束时间'],
                style: {"width":"250px"}
              }, {
                suffixIcon: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 6,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _createVNode(_component_a_select, {
                value: _ctx.searchParam.isSampled,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchParam.isSampled) = $event)),
                style: {"width":"250px"},
                ref: "select",
                Clear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.isSampledArray, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 7,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_15,
              _createVNode(_component_a_select, {
                value: _ctx.searchParam.submitMode,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchParam.submitMode) = $event)),
                style: {"width":"250px"},
                ref: "select",
                Clear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submitModeArray, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 8,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _createVNode(_component_a_select, {
                value: _ctx.searchParam.checkingResult,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchParam.checkingResult) = $event)),
                style: {"width":"250px"},
                ref: "select",
                Clear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkingResultArray, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.value,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 9,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_17,
              _createVNode(_component_a_input, {
                value: _ctx.searchParam.dealerName,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.searchParam.dealerName) = $event)),
                placeholder: "请输入",
                style: {"width":"250px"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 10,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _createVNode(_component_a_input, {
                value: _ctx.searchParam.dealerCode,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchParam.dealerCode) = $event)),
                placeholder: "请输入",
                style: {"width":"250px"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 11,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_19,
              _createVNode(_component_a_input, {
                value: _ctx.searchParam.swtCode,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.searchParam.swtCode) = $event)),
                placeholder: "请输入",
                style: {"width":"250px"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 12,
            direction: "vertical",
            class: "spaceMargin"
          }, {
            default: _withCtx(() => [
              _hoisted_20,
              _createVNode(_component_a_select, {
                value: _ctx.searchParam.isAppeal,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.searchParam.isAppeal) = $event)),
                style: {"width":"250px"},
                ref: "select",
                placeholder: "Please Select",
                allowClear: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "Y" }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "N" }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_space, {
        direction: "vertical",
        class: "right-button"
      }, {
        default: _withCtx(() => [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            (_ctx.$btnPermissions('VL0018'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  class: "mr15 button",
                  onClick: _ctx.resetEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.$btnPermissions('VL0019'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  type: "primary",
                  class: "mr15 button",
                  onClick: _ctx.searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (!_ctx.isOpen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "expandText",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => {
            _ctx.isOpen = true;
            _ctx.refreshTableHeight();
          })
                }, _hoisted_29))
              : _createCommentVNode("", true),
            (_ctx.isOpen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "expandText",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => {
            _ctx.isOpen = false;
            _ctx.refreshTableHeight();
          })
                }, _hoisted_32))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.batchQuery.batchQueryModal,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.batchQuery.batchQueryModal) = $event)),
      width: 420,
      onCancel: _ctx.closeBatchQueryModal,
      class: "batch-query-modal",
      centered: ""
    }, {
      title: _withCtx(() => [
        _createElementVNode("strong", _hoisted_33, _toDisplayString(_ctx.batchQuery.batchQueryTitle), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _ctx.clearBatchQuery
        }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          size: "small",
          type: "primary",
          onClick: _cache[20] || (_cache[20] = ($event: any) => {
          _ctx.batchQuery.batchQueryModal = false;
          _ctx.closeBatchQueryModal();
        })
        }, {
          default: _withCtx(() => [
            _hoisted_38
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("article", null, [
            _createElementVNode("section", _hoisted_35, _toDisplayString(_ctx.batchQuery.batchQueryListTitle), 1),
            _createElementVNode("section", _hoisted_36, [
              (_ctx.textNoArray.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.textNoArray, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "list-item",
                      key: index
                    }, _toDisplayString(item), 1))
                  }), 128))
                : _createCommentVNode("", true),
              _createVNode(_component_a_input, {
                ref: "input",
                value: _ctx.textContentNo,
                "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.textContentNo) = $event)),
                onChange: _ctx.textChangEvent,
                style: {"height":"24px"}
              }, null, 8, ["value", "onChange"]),
              (_ctx.batchPlaceholder.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.batchPlaceholder, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "list-item",
                      style: {"height":"24px","margin-top":"8px"}
                    }))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ], 64))
}